export const USABLE: string = "usable";
export const CANCELED: string = "canceled";
export const UPDATED: string = "update";
export const CORRECTED: string = "correction";
export const REPEATED: string = "repeat";
